import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

const IN_VIEW = { opacity: 1, y: 0 };
const VIEWPORT = { once: true, margin: "-60px" };
const LINE_VARIANTS = { hidden: { y: "115%" }, show: { y: "0%" } };

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={IN_VIEW}
    viewport={VIEWPORT}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, inView = true }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(inView
      ? { whileInView: "show", viewport: { once: true, margin: "-40px" } }
      : { animate: "show" })}
  >
    {lines.map((line, i) => (
      <span key={line?.key ?? `line-${i}`} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
        <motion.span
          className={`block will-change-transform ${lineClassName}`}
          variants={LINE_VARIANTS}
          transition={{ duration: 0.9, delay: delay + i * 0.12, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const ChapterNumber = ({ n, className = "" }) => (
  <span
    className={`font-mono text-xs tracking-[0.3em] text-mist ${className}`}
  >
    {n}
  </span>
);
